module.exports = __webpack_public_path__ + "static/media/search-white.1505cf76.svg";